// extracted by mini-css-extract-plugin
export var searchFilter = "search-filter-module--searchFilter--E8mlQ";
export var selectArea = "search-filter-module--selectArea--bQEoH";
export var selectAreaItem = "search-filter-module--selectAreaItem--IpoVD";
export var inputSelect = "search-filter-module--inputSelect--ufEMq";